module.exports = __webpack_public_path__ + "static/media/e&ohead.290329e4.jpg";